/* eslint-disable eqeqeq */
import React from "react";
import getUserType from "../getUserType";
import { PAYMENT_RECEIVER_TYPE, PAYMENT_STATUS } from "../data";
import getPaymentStatus from "../getPaymentStatus";
import ListDropdown from "./ListDropdown";

const farmerPaymentColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Name
      </div>
    ),
    dataIndex: "firstName",
    sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    render: (text, record) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-black capitalize">
        {text} {record?.lastName}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Main Hub
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a.hubName.localeCompare(b.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        User Type
      </div>
    ),
    dataIndex: "entityType",
    sorter: (a, b) => a.entityType - b.entityType,
    render: () => (
      <div className="max-w-max">
        {getUserType(PAYMENT_RECEIVER_TYPE.FARMER)}
      </div>
    ),
  },
  // {
  //   title: () => (
  //     <div className="font-normal font-aileron text-10 text-dark-gray">
  //       No. of Trips Due
  //     </div>
  //   ),
  //   dataIndex: "firstName",
  //   sorter: (a, b) => sortByTripsDue(a, b),
  //   render: (text, record) => <TripsDue payment={record} />,
  // },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Total Amount Due
      </div>
    ),
    dataIndex: "totalAmountDue",
    sorter: (a, b) => a.totalAmountDue - b.totalAmountDue,
    render: (text, record) => {
      const value = record.totalAmountDue - record.totalAmountPaid;

      return (
        <div className="text-xs font-medium font-poppins leading-4.5">
          {value > 0 ? `${value} KSH` : "--"}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Payment Status
      </div>
    ),
    dataIndex: "paymentStatus",
    render: (text, record) => {
      if (record.totalAmountDue == 0 && record.totalAmountPaid == 0) {
        return <div>--</div>;
      }

      const status =
        record.totalAmountDue === record.totalAmountPaid
          ? PAYMENT_STATUS.COMPLETED
          : PAYMENT_STATUS.PENDING;

      return <div>{getPaymentStatus(status)}</div>;
    },
  },
  {
    dataIndex: "id",
    render: (text, record) => (
      <div
        className="invisible group-hover:visible"
        onClick={(e) => e.stopPropagation()}
      >
        {record?.totalAmountDue > 0 ? <ListDropdown detail={record} /> : null}
      </div>
    ),
  },
];

const driverPaymentColumns = [
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Name
      </div>
    ),
    dataIndex: "firstName",
    sorter: (a, b) => a.firstName.localeCompare(b.firstName),
    render: (text, record) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-black capitalize">
        {text} {record?.lastName}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Main Hub
      </div>
    ),
    dataIndex: "hubName",
    sorter: (a, b) => a.hubName.localeCompare(b.hubName),
    render: (text) => (
      <div className="text-xs font-semibold font-aileron leading-4.5 text-dark-gray capitalize">
        {text}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        User Type
      </div>
    ),
    dataIndex: "id",
    // sorter: (a, b) => a.entityType - b.entityType,
    render: () => (
      <div className="max-w-max">
        {getUserType(PAYMENT_RECEIVER_TYPE.DRIVER)}
      </div>
    ),
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Total Amount Due
      </div>
    ),
    dataIndex: "totalAmountDue",
    sorter: (a, b) => a.totalAmountDue - b.totalAmountDue,
    render: (text, record) => {
      const value = record.totalAmountDue;

      return (
        <div className="text-xs font-medium font-poppins leading-4.5">
          {value > 0 ? `${value} KSH` : "--"}
        </div>
      );
    },
  },
  {
    title: () => (
      <div className="font-normal font-aileron text-10 text-dark-gray">
        Payment Status
      </div>
    ),
    dataIndex: "paymentStatus",
    render: (text, record) => {
      if (record.totalAmountDue == 0 && record.totalAmountPaid == 0) {
        return <div>--</div>;
      }

      let status = PAYMENT_STATUS.PENDING;

      if (record?.totalAmountDue > 0) {
        status = PAYMENT_STATUS.PENDING;
      }

      if (record.totalAmountPaid > 0 && record?.totalAmountDue === 0) {
        status = PAYMENT_STATUS.COMPLETED;
      }

      return <div>{getPaymentStatus(status)}</div>;
    },
  },
  {
    dataIndex: "id",
    render: (text, record) => (
      <div
        className="invisible group-hover:visible"
        onClick={(e) => e.stopPropagation()}
      >
        {record?.totalAmountDue > 0 ? <ListDropdown detail={record} /> : null}
      </div>
    ),
  },
];

const useColumns = (selectedView) => {
  if (selectedView === PAYMENT_RECEIVER_TYPE.FARMER)
    return farmerPaymentColumns;
  if (selectedView === PAYMENT_RECEIVER_TYPE.DRIVER)
    return driverPaymentColumns;

  return [];
};

export default useColumns;
